import React from "react"
import { Link } from "gatsby"

const AboutFooterMenu = () => {
  return (
    <React.Fragment>
      <Link to="/about">Who We Are</Link>
      <Link to="/timeline">Our History</Link>
      <Link to="/cares-team">AES C.A.R.E.S Team</Link>
      <Link
        to="https://recruiting.paylocity.com/recruiting/jobs/All/da9c5e97-8c64-49a3-aaac-4d89309ecf1f/Advanced-Electronic-Services-Inc"
        target="_blank"
      >
        Join Our Team
      </Link>
      <Link to="/process">Repair Process</Link>
      <Link to="/review">Customer Reviews!</Link>
      <Link to="/contact-us">Contact Information</Link>
      <Link to="/why-choose-us">Why Choose Us</Link>
    </React.Fragment>
  )
}

export default AboutFooterMenu
